export const getCenteredStyle = (isTable: boolean): Dic<string> => ({
  width: "100%",
  minHeight: isTable ? "100px" : "70vh",
  alignItems: "center",
  justifyContent: "center",
});
